import { CheckpointCreate, CheckpointEdit, CheckpointList } from './CashflowSetupCheckpoints'

export default {
  list: CheckpointList,
  create: CheckpointCreate,
  edit: CheckpointEdit,
}
